import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { ROUTES } from "@/constants/routeConstants";
import { AnalyticsDashboard } from "@/features/analytics/AnalyticsDashboard";
import { PostSignupApiKeyPrompt } from "@/features/analytics/components/PostSignupApiKeyPrompt";

function AnalyticsRoute() {
  const navigate = useNavigate();

  return (
    <>
      <AnalyticsDashboard />
      <PostSignupApiKeyPrompt
        onCreateApiKey={() => void navigate({ to: ROUTES.API_KEYS })}
      />
    </>
  );
}

export const Route = createFileRoute("/_layout/analytics")({
  component: AnalyticsRoute,
});
